import React, { useEffect, useState } from "react";
import { getBirthdays } from "../Service/Api";

function BirthDay() {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const birthdayData = await getBirthdays();
        setData(birthdayData);
      } catch (error) {
        console.error("Error fetching birthdays:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="col-lg-4 col-md-6">
      <div className="birthday-card text-center p-3">
        <div
          id="birthdayCarousel"
          className="carousel slide"
          data-bs-ride="carousel"
          data-bs-interval="3000">
          <div className="carousel-inner">
            {/* Dynamic birthdays */}
            {data.length > 0 ? (
              data.map((item, index) => (
                <div
                  className={`carousel-item ${index === 0 ? "active" : ""}`}
                  key={index}>
                  <img
                    src={
                      item.attachments?.length > 0
                        ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com?url=${item.attachments}`
                        : "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/student.png"
                    }
                    alt="Birthday Student"
                    className="img-fluid birthday-img mb-2"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src =
                        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/profilethumb.png";
                    }}
                  />

                  <h6 className="birthday-name mt-2">{item.name}</h6>
                  <p className="birthday-class">Class {item.class}</p>
                </div>
              ))
            ) : (
              // fallback when no data
              <div className="carousel-item active">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/student.png"
                  alt="Birthday Student"
                  className="img-fluid birthday-img mb-2"
                />
                <h6 className="birthday-name mt-2">Student Name</h6>
                <p className="birthday-class">Class</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BirthDay;
